import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Fade, DialogContent, Dialog, DialogActions, AppBar, Toolbar, IconButton, Slide } from '@material-ui/core';
import withUser from '../HOC/HOCwithUser.jsx';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import TextField from '@material-ui/core/TextField';
import axios from 'axios';
import {
    Button,
    CircularProgress,
    Paper,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Chip,
    TableFooter
} from '@material-ui/core';
import ProgressiveImage from 'react-progressive-image';
import ContentLoader from 'react-content-loader';
import { FormattedMessage, injectIntl } from 'react-intl';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import HOCSectionLoader from '../HOC/HOCSectionLoader.jsx';
import {
    getBookingStatusClass,
    convertTimestampToDate,
    BOOKING_STATUS_INCART,
    getBookingPaymentStatus,
    getBookingPaymentStatusClass,
    getPaymentType,
    getPaymentTypeClass,
    ROLE_CUSTOMER,
    ROLE_PROVIDER,
    PAYMENT_PENDING,
    PAYMENT_Refund,
    secondsToHms,
    APP_NAME,
    BOOKING_STATUS_CANCELLED,
    BOOKING_STATUS_REJECTED,
    SERVER_URL,
    getOffSetTime,
    BOOKING_STATUS_REBOOK,
    BOOKING_STATUS_NOSP,
    BOOKING_STATUS_NOSHOW
} from '../../utils/config/constants.js';
import { NotificationManager } from 'react-notifications';
import { getDay, tConvert, tConvert3Add } from '../../utils/config/constants';
import {
    BOOKING_STATUS_INITIATED,
    BOOKING_STATUS_CONFIRMED,
    BOOKING_STATUS_START,
    BOOKING_STATUS_PAUSED,
    BOOKING_STATUS_END,
    BOOKING_STATUS_COMPLETED,
} from '../../utils/config/constants';
import withCustomTheme from '../HOC/HOCwithCustomTheme.jsx';
import { Redirect } from 'react-router-dom';
import RatingPopup from './RatingPopup.jsx';
import { Check, Close } from '@material-ui/icons';
import { getCookies } from '../../utils/getToken.js';
import BookingTimeSlotPopup from '../Booking/BookingTimeSlotPopup.jsx';
import DateTimePanel from '../Booking/DateTimePanel.jsx';
import StarRatings from 'react-star-ratings';

import {
    FacebookShareButton,
    TwitterShareButton,
    EmailShareButton,
    FacebookIcon,
    TwitterIcon,
    EmailIcon
} from "react-share";
import instgram from 'assets/images/instagram.png'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import { Clear, Add, Remove, GpsFixed, LocationOn } from '@material-ui/icons';


var socialMsg = ""


const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    },
    margin: {
        margin: theme.spacing.unit
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '10px'
    }
});
let isMounted = false;
class BookingDetail extends React.Component {
    constructor(props) {
        super();
        this.state = {
            page: 1,
            scrollClicked: false,
            isResRejecting: false,
            isResAccepting: false,
            data: {},
            loader: true,
            showPaymentOption: false,
            cardPayment: false,
            walletPayment: false,
            ratePopup: false,
            bookingId: props.location.bookingId | props.bookingId,
            bookingList: false,
            actionLoader: false,
            redirect: false,
            ratingDone: false,
            isBookingCancelled: false,
            isRebooking: false,
            showPayButton: true,
            isProviderBlocked: false,
            showBlockProviderButton: true,
            showReschedulePopup: false,
            showRebookPopup: false,
            openDateTime: false,
            dateTimeValue: "",
            slots: [],
            haveSlots: false,
            timeSlot: "",
            isTodaySlot: false,
            bookingTimeSlot: "",
            reason: "",
            showRefundBtn: true,
            showRefundPopup: false,
            reasonRefund: "",
            x: 0,
            showShareIcon: false,
            recurring: props.location.recurring | false,
            showRecurringStop: true,
            showNosp: true,
            isAccepting: false,
            isRejecting: false,
            showRaisePriceModel: false,
            raiseReason: "",
            raisePrice: "",
            showRateCustomerPopup: false,
            reviewCustomer: "",
            r1: 1,
            sosLoader: false,
            emergencyLoader: false,
            zoomImageModal: false,
            zoomSrc: "",


        };
    }

    componentDidMount() {
        isMounted = true;
        this.props.notificationListAction();
        this.getData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.bookingId != this.props.location.bookingId) {
            if (isMounted) {
                this.getData();
            }
        }
    }

    getData = () => {
        console.log("Booking Id:::::", this.props.bookingId)
        this.props.bookingDetailAction(
            {
                bookingId: this.props.bookingId
            },
            this.onDone
        );
    };
    onDone = (success, data) => {
        // console.log(" Booking detail data:::::::::::::::", data.length)
        // console.log(" Booking detail data:::::::::::::::", data.json)

        if (success) {
            // console.log(" Booking2", JSON.stringify(data))
            this.setState({ data: data.data, loader: false });
        } else {
            this.setState({ loader: true }, () => { this.getData() }); // Jugggggggaaaadddddddd need to correct
            /* NotificationManager.success(data.message, 'Error'); */  // Jugggggggaaaadddddddd need to correct
        }
    };

    renderPromoImage = () => {
        return (
            <div style={{ width: 200, height: 200 }}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="2" ry="2" width="200" height="200" />
                </ContentLoader>
            </div>
        );
    };

    renderService = data => {

        if (!data.services) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    {data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].service : data.services[0].service : "No Service Choosen"}
                </div>
            );
        }
    };

    renderServicecategory = data => {
        console.log('mmmm', data)

        if (!data.services) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    {data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].full_name_category : data.services[0].full_name_category : "No Service Choosen"}
                </div>
            );
        }
    };



    renderServicemastercategory = data => {

        if (!data.services) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    {data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].full_name_master_category : data.services[0].full_name_master_category : "No Service Choosen"}
                </div>
            );
        }
    };
    renderServicePrice = data => {
        if (!data.services) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    {this.props.settings.constants.CURRENCY_SYMBOL}
                    {data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].present_charge
                        : data.services[0].servicePrice + "hr" : "0"}
                </div>
            );

        }
    };
    DiscountedAmount = data => {

        // {data.total_amount
        // ? data.total_amount
        // : '0'}

        if (!data.services) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    {/* {this.props.settings.constants.CURRENCY_SYMBOL} */}
                    {/* {Number((data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].present_charge
                        : data.services[0].servicePrice   : "0") - (data.total_amount ? data.total_amount: '0')).toFixed(2)} */}
                    {/* {(data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].present_charge
                        : data.services[0].servicePrice   : "0") - (data.total_amount ? data.total_amount: '0') } */}
                    {"$"}{Number((data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].present_charge
                        : data.services[0].servicePrice : "0") - (data.total_amount)).toFixed(2)}
                </div>
            );

        }




    };

    renderServicetype = data => {
        if (!data.services) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    {data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].service_type : data.services[0].service_type : "-"}
                </div>
            );
        }
    };


    renderprice = data => {
        if (!data.services) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    {data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].present_charge : data.services[0].present_charge : "-"}
                </div>
            );
        }
    };

    renderprowiderprice = data => {
        if (!data.services) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    {/* {(data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].present_charge : data.services[0].present_charge : "-")-data.admin_amount} */}


                    {Number(data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].present_charge : data.services[0].present_charge : "-") - (data.admin_amount) / (data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                            ? data.services[0].quantity : data.services[0].quantity : "-").toFixed(2)
                    }
                </div>
            );
        }
    };
    renderTotalAmount = data => {
        if (!data.services) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    {(data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].total_charge : data.services[0].total_charge : "-")}
                </div>
            );
        }
    };



    renderTotalAmountprice = data => {
        if (!data.services) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    {Number(data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].total_charge : data.services[0].total_charge : "-") - (data.admin_amount).toFixed(2)}


                    {/* {(data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].total_charge : data.services[0].total_charge : "-")-(data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].quantity : data.services[0].quantity : "-")*(data.admin_amount)} */}
                </div>
            );
        }
    };





    renderServiceQty = data => {
        if (!data.services) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    {data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].quantity : data.services[0].quantity : "0"}
                </div>
            );
        }
    };


    rendertotal = data => {
        if (!data.services) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    {"$"} {Number((data.services.length > 0 ? data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].total_charge : data.services[0].total_charge : "0") * (data.promo_code ? data.promo_code.percent_amount : '-') / 100).toFixed()}
                </div>

            );
        }
    };

    cancelBooking2 = data => {
        if (window.confirm("Are you sure ?")) {
            this.props.cancelBookingsp(
                {
                    bookingId: data.key
                },
                this.onCancelDone2
            );
        }
        else {
            console.log("cancel sp")
        }
    };

    onCancelDone2 = (success, data) => {
        if (success) {
            this.setState({ isBookingCancelled: true });
            NotificationManager.success(
                <FormattedMessage
                    id="bookingCancelledSuccess"
                    defaultMessage="Booking Cancelled Successfully"
                    href="javascript:void(0)"
                />,
                'Cancelled'
            );
            this.props.history.push({
                pathname: `/user/booking/detail/${this.state.data.key}`
            });
        } else {
            NotificationManager.error(data, 'Error');
        }
    };


    cancelBooking = data => {
        if (window.confirm("Are you sure ?")) {
            this.props.cancelBookingAction(
                {
                    bookingId: data.key
                },
                this.onCancelDone
            );
        }
        else {
            console.log("cancel")
        }
    };
    onCancelDone = (success, data) => {
        if (success) {
            this.setState({ isBookingCancelled: true });
            NotificationManager.success(
                <FormattedMessage
                    id="bookingCancelledSuccess"
                    defaultMessage="Booking Cancelled Successfully"
                    href="javascript:void(0)"
                />,
                'Cancelled'
            );
            this.props.history.push({
                pathname: `/user/booking/detail/${this.state.data.key}`,

            });
        } else {
            NotificationManager.error(data, 'Error');
        }
    };

    renderCancelOption = data => {
        console.log("Inside Render Cancle Option")
        return (
            <div className="md-12 row" style={{ justifyContent: "space-between" }}>
                {data.isCancellable && <Button
                    variant="contained"
                    onClick={() => this.cancelBooking(data)}
                    style={{ backgroundColor: "#ff0000", color: "#ffffff" }}
                >
                    <FormattedMessage
                        id="cancelBooking"
                        defaultMessage="Cancel Booking"
                    />
                </Button>}

                {!data.reschedule_status ?
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.onReschedule(data)}
                    >
                        <FormattedMessage id="Reschedule" defaultMessage="Reschedule" />
                    </Button> : null}
                {data.reschedule_info.request_made_by == 'provider' && !data.reschedule_info.user_responded ?
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.onRescheduleAccept(data)}
                    >
                        <FormattedMessage id="Accept Reschedule" defaultMessage="Accept Reschedule" />
                    </Button> : null
                }
                {data.reschedule_info.request_made_by == 'provider' && !data.reschedule_info.user_responded ?
                    <Button
                        variant="contained"
                        style={{ backgroundColor: "#ff0000", color: "#ffffff" }}
                        onClick={() => this.onRescheduleReject(data)}
                    >
                        <FormattedMessage id="Reject Reschedule" defaultMessage="Reject Reschedule" />
                    </Button> : null
                }
            </div>
        );
    };



    renderRebookCancelOption = data => {
        console.log("Inside Render Cancle Option")
        return (
            <div className="md-12 row" style={{ justifyContent: "space-between" }}>

                {!this.state
                    .isBookingCancelled &&
                    <Button
                        variant="contained"
                        onClick={() => this.cancelBooking2(data)}
                        style={{ backgroundColor: "#ff0000", color: "#ffffff" }}
                    >
                        <FormattedMessage
                            id="cancelBooking"
                            defaultMessage="Cancel Booking"
                            href="javascript:void(0)"
                        />
                    </Button>}


                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.onRebookjob(data)}
                >
                    <FormattedMessage id="Rebook Job" defaultMessage="Rebook Job" />
                </Button>


            </div>
        );
    };








    renderCancelProviderOption = data => {

        return (

            <div className="md-12 row" style={{ justifyContent: "space-between" }}>
                {!this.state
                    .isBookingCancelled && <Button
                        variant="contained"
                        color="primary"
                        style={{ background: "#ff0000", color: "#ffffff" }}
                        onClick={() => this.cancelBooking(data)}
                    >
                        <FormattedMessage
                            id="cancelBooking"
                            defaultMessage="Cancel Booking"
                        />
                    </Button>}


                {!data.reschedule_status ?
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.onReschedule(data)}
                    >
                        <FormattedMessage id="Reschedule" defaultMessage="Reschedule" />
                    </Button> : null}

                {data.reschedule_info.request_made_by == 'user' && !data.reschedule_info.user_responded ?
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.onRescheduleAccept(data)}
                    >
                        <FormattedMessage id="Accept Reschedule" defaultMessage="Accept Reschedule" />
                    </Button> : null
                }
                {data.reschedule_info.request_made_by == 'user' && !data.reschedule_info.user_responded ?
                    <Button
                        variant="contained"
                        style={{ backgroundColor: "#ff0000", color: "#ffffff" }}
                        onClick={() => this.onRescheduleReject(data)}
                    >
                        <FormattedMessage id="Reject Reschedule" defaultMessage="Reject Reschedule" />
                    </Button> : null
                }


            </div>
        )

    }

    onRecurringStop = (data) => {
        var authToken = getCookies();
        axios({
            method: 'post',
            data: {
                booking_id: data.key,
            },
            url: `${SERVER_URL}/booking/stop-recurring`,
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            if (resJson.data.status == "OK") {
                NotificationManager.success("Success", resJson.data.message)
                this.setState({
                    showRecurringStop: false
                })
            } else {
                NotificationManager.error("Oops", resJson.data.message)
                this.setState({
                    showRecurringStop: true
                })
            }
        })
    }

    Nospavailable = (data) => {
        var authToken = getCookies();
        axios({
            method: 'post',
            data: {
                booking_id: data.key,
            },
            url: `${SERVER_URL}/booking/not-available`,
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            if (resJson.data.status == "OK") {
                NotificationManager.success("Success", resJson.data.message)
                this.setState({
                    showNosp: false
                })
            } else {
                NotificationManager.error("Oops", resJson.data.message)
                this.setState({
                    showNosp: true
                })
            }
        })
    }

    onRescheduleClick = (data) => {
        console.log("jjj", data)
        // alert(data.key);
        if (this.state.bookingTimeSlot == "" || this.state.dateTimeValue == "") {
            NotificationManager.error("Opps", "Choose date and time")

        } else {
            var authToken = getCookies();
            axios({
                method: 'post',
                data: {
                    bookingToken: data.key,
                    date: this.state.dateTimeValue,
                    time: getOffSetTime(this.state.bookingTimeSlot.start),
                    reason: this.state.reason
                },
                url: `${SERVER_URL}/booking/reschedule`,
                headers: { 'x-auth-token': authToken }
            }).then(resJson => {
                if (resJson.data.status == "OK") {

                    NotificationManager.success("Success", resJson.data.message)
                    this.setState({
                        showReschedulePopup: false
                    }, () => { this.getData() })
                    console.log("Success", resJson.data.message)

                } else {
                    NotificationManager.error("Oops", resJson.data.message)
                    this.setState({
                        showReschedulePopup: false
                    })
                }
            })

        }

    }

    onREBOOKClick = (data) => {
        console.log("Rebookjob", data)
        // alert(data.key);
        if (this.state.bookingTimeSlot == "" || this.state.dateTimeValue == "") {
            NotificationManager.error("Opps", "Choose date and time")

        } else {
            var authToken = getCookies();
            axios({
                method: 'post',
                data: {
                    bookingId: data.key,
                    date: this.state.dateTimeValue,
                    time: getOffSetTime(this.state.bookingTimeSlot.start),
                    // reason: this.state.reason
                },
                url: `${SERVER_URL}/booking/change-time`,
                headers: { 'x-auth-token': authToken }
            }).then(resJson => {
                if (resJson.data.status == "OK") {

                    NotificationManager.success("Success", resJson.data.message)
                    this.setState({
                        showRebookPopup: false
                    }, () => { this.getData() })
                    console.log("Success", resJson.data.message)

                } else {
                    NotificationManager.error("Oops", resJson.data.message)
                    this.setState({
                        showRebookPopup: false
                    })
                }
            })

        }

    }


    onRescheduleAccept = (data) => {
        var authToken = getCookies();
        axios({
            method: 'post',
            data: {
                request_id: data.reschedule_info.id
            },
            url: `${SERVER_URL}/reschedule/accept`,
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            if (resJson.data.status == "OK") {
                NotificationManager.success("Success", resJson.data.message)
                this.setState({
                    isResAccepting: false
                }, () => { this.getData() })
            } else {
                NotificationManager.error("Oops", resJson.data.message)
                this.setState({
                    isResAccepting: false
                })
            }
        })
    }


    onRescheduleReject = (data) => {
        var authToken = getCookies();
        axios({
            method: 'post',
            data: {
                request_id: data.reschedule_info.id
            },
            url: `${SERVER_URL}/reschedule/reject`,
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            if (resJson.data.status == "OK") {
                NotificationManager.success("Success", resJson.data.message)
                this.setState({
                    isResRejecting: false
                }, () => { this.getData() })
            } else {
                NotificationManager.error("Oops", resJson.data.message)
                this.setState({
                    isResRejecting: false
                })
            }
        })
    }


    onReschedule = (data) => {
        this.setState({
            showReschedulePopup: true,
        })

    }
    onRebookjob = (data) => {
        this.setState({
            showRebookPopup: true,
        })

    }


    renderRescheduleBtn = data => {

        return (
            <div className="text-center">
                <Button
                    className="ml-2"
                    variant="contained"
                    color="primary"
                    onClick={() => this.onReschedule(data)}
                >
                    <FormattedMessage id="Reschedule" defaultMessage="Reschedule" />
                </Button>

            </div>

        );
    };

    renderRebookOption = data => {
        if (this.state.data.reschedule && !data.is_blocked) {
            if (this.state.isRebooking) {
                return <CircularProgress />;
            }
            return (
                <Button
                    className="Rebook_div"
                    variant="contained"
                    color="primary"
                    onClick={() => this.onRebook(data)}
                >
                    <FormattedMessage id="rebook" defaultMessage="Rebook" />
                </Button>
            );
        }
    };
    onRebook = () => {
        this.setState({ isRebooking: true });
        this.props.reBookingAction(
            {
                bookingId: this.state.data.key
            },
            (success, data) => {
                console.log("Rebook data:::::", data)
                this.setState({ isRebooking: false });
                if (success) {
                    this.props.history.push({
                        pathname: `/book/service/${data.providerDetail.id}/${data.webServiceId
                            }`,
                        state: {
                            serviceDataSource: [{
                                id: data.webServiceId,
                                qty: data.quantity
                            }]
                        }
                    });
                } else {
                    NotificationManager.error(data, 'Error');
                }
            }
        );
    };
    renderActions = data => {



        // console.log(" msmms ", BOOKING_STATUS_NOSHOW + " data.statusId " + data.statusId)
        // if(data.statusId == BOOKING_STATUS_NOSHOW){
        //     console.log(" msmms2 ", BOOKING_STATUS_NOSHOW + " data.statusId " + data.statusId)
        //     return (
        //         <div className="text-center gg d-flex box_box" style={{ justifyContent: "space-evenly" }}>
        //             {this.renderRebookOption(data)}
        //             <p>kapil</p>
        //         </div>
        //     );
        // }

        /*  console.log("sdmsdas", (data.isCancellable && !data.reschedule_status))
         if (data.isCancellable && !data.reschedule_status) {
             return (<div>{this.renderRescheduleBtn(data)}</div>)
 
         }
         if (data.isCancellable) {
             return this.renderCancelOption(data)
         }
         if (data.can_request_refund) {
             return this.renderRefundButton(data)
         }
         if (data.reschedule && !data.is_blocked) {
             return this.renderRebookOption(data)
         }
         if (BOOKING_STATUS_START == data.statusId ||
             BOOKING_STATUS_PAUSED == data.statusId) {
             return <div className="text-center d-flex" style={{ justifyContent: "space-evenly" }}>
 
                 {this.renderSosButton()}
                 {this.renderEmergencyButton()}
             </div>
         }
         if (data.statusId == BOOKING_STATUS_INITIATED) {
             return (
                 <div className="text-center">
 
                     <p>
                         <b>
                             {' '}
                             <FormattedMessage
                                 id="waitingForProviderText"
                                 defaultMessage="Waiting for provider to accept."
                             />
                         </b>
                     </p>
                 </div>
             );
         }
         if (
             data.statusId == BOOKING_STATUS_END ||
             data.statusId == BOOKING_STATUS_COMPLETED
         ) {
             return (
                 <div className="text-center d-flex" style={{ justifyContent: "space-evenly" }}>
                     {this.renderPayButton(data)}
                     {this.renderReviewButton(data)}
                     {this.renderBlockProviderButton(data)}
 
                 </div>
             );
         } */


        if (data.statusId == BOOKING_STATUS_REBOOK) {

            console.log("mrf", BOOKING_STATUS_REBOOK)

            if (data.statusId == BOOKING_STATUS_REBOOK) {
                return (
                    <div className="text-center">

                        <p>
                            <b>
                                {' '}
                                <FormattedMessage
                                    id="NOProvider"
                                    defaultMessage="NO Provider Available."
                                />
                            </b>
                        </p>
                        {this.renderRebookCancelOption(data)}
                    </div>
                );
            } else {
                return (<div>{this.renderRebookCancelOption(data)}</div>)
            }
        }


        if (data.statusId == BOOKING_STATUS_NOSHOW) {

            console.log("kapil", BOOKING_STATUS_NOSHOW)

            if (data.statusId == BOOKING_STATUS_NOSHOW) {
                return (
                    <div className="text-center">

                        <p>
                            <b>
                                {' '}
                                <FormattedMessage
                                    id="NOProviderstart"
                                    defaultMessage="NO Provider Start Job."
                                />
                            </b>
                        </p>
                        <Button
                            className="Rebook_div"
                            variant="contained"
                            color="primary"
                            onClick={() => this.onRebook(data)}
                        >
                            <FormattedMessage id="rebook" defaultMessage="Rebook" />
                        </Button>
                    </div>
                );
            } else {
                return (<div>
                    <Button
                        className="Rebook_div"
                        variant="contained"
                        color="primary"
                        onClick={() => this.onRebook(data)}
                    >
                        <FormattedMessage id="rebook" defaultMessage="Rebook" />
                    </Button></div>)
            }
        }
        if (
            data.statusId == BOOKING_STATUS_INITIATED ||
            data.statusId == BOOKING_STATUS_CONFIRMED
        ) {
            if (data.statusId == BOOKING_STATUS_INITIATED) {
                return (
                    <div className="text-center">

                        <p>

                            <b>
                                {' '}
                                <FormattedMessage
                                    id="waitingForProviderText"
                                    defaultMessage="Waiting for provider to accept."
                                />
                            </b>
                        </p>
                        {this.renderCancelOption(data)}
                    </div>
                );
            } else {
                return (<div>{this.renderCancelOption(data)}</div>)
            }

        }
        if (data.statusId == BOOKING_STATUS_START ||
            data.statusId == BOOKING_STATUS_PAUSED) {
            return (<div className="text-center  d-flex" style={{ justifyContent: "space-evenly" }}>
                {this.renderEmergencyButton(data)}

            </div>);
        }
        if (data.statusId == BOOKING_STATUS_INCART) {
            return (
                <div className="d-flex" style={{ justifyContent: "space-evenly" }}>
                    <div className="paybtn">{this.renderCancelOption(data)}</div>
                    <div className="text-center">{this.renderPayButton(data)}</div>
                </div>
            );
        } else if (
            data.statusId == BOOKING_STATUS_END ||
            data.statusId == BOOKING_STATUS_COMPLETED
        ) {
            return (
                <div className="text-center gg d-flex box_box" style={{ justifyContent: "space-evenly" }}>
                    {this.renderPayButton(data)}
                    {this.renderReviewButton(data)}
                    {this.renderRebookOption(data)}
                    {this.renderBlockProviderButton(data)}
                    {this.renderRefundButton(data)}

                </div>
            );
        }

    };


    emergencyStop = (data) => {

        this.setState({
            emergencyLoader: true
        })
        var authToken = getCookies();
        axios({
            method: 'post',
            data: {
                booking_id: data.key,
            },
            url: `${SERVER_URL}/booking/emergency-stop`,
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            if (resJson.data.status == "OK") {
                NotificationManager.success("Success", resJson.data.message)
                this.setState({
                    emergencyLoader: false
                })
            } else {
                NotificationManager.error("Oops", resJson.data.message)
                this.setState({
                    emergencyLoader: false
                })
            }
        })

    }

    handleRaiseRequestAccept = (data) => {

        var authToken = getCookies();
        axios({
            method: 'post',
            data: {
                bookingToken: data.token,
            },
            url: `${SERVER_URL}/booking/accept-raise`,
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            if (resJson.data.status == "OK") {
                NotificationManager.success("Success", resJson.data.message)
                this.getData();
            } else {
                NotificationManager.error("Oops", resJson.data.message)
            }
        })

    }

    handleRaiseRequestReject = (data) => {
        var authToken = getCookies();
        axios({
            method: 'post',
            data: {
                bookingToken: data.token,
            },
            url: `${SERVER_URL}/booking/reject-raise`,
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            if (resJson.data.status == "OK") {
                NotificationManager.success("Success", resJson.data.message)
                this.getData();
            } else {
                NotificationManager.error("Oops", resJson.data.message)
            }
        })

    }

    rateCustomer = (data) => {
        var authToken = getCookies();
        axios({
            method: 'post',
            data: {
                bookingToken: data.token,
                r1: this.state.r1,
                r2: this.state.r1,
                r3: this.state.r1,
                review: this.state.reviewCustomer,
            },
            url: `${SERVER_URL}/rating/add`,
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            if (resJson.data.status == "OK") {
                NotificationManager.success("Success", resJson.data.message)
                this.handleCloseRateCustomerPopup()
                this.getData();
            } else {
                NotificationManager.error("Oops", resJson.data.message)
            }
        })

    }


    renderEmergencyButton = data => {

        if (this.state.emergencyLoader) {
            return (
                <CircularProgress />
            )
        } else {
            return (
                <Button
                    variant="contained"
                    style={{ backgroundColor: "#ff0000", color: "#ffffff" }}

                    onClick={() => { this.emergencyStop(data) }}
                >
                    Emergency Stop
                </Button>
            );

        }

    }
    renderReviewButton = data => {
        if (!data.customer_reviewed && !this.state.ratingDone) {
            return (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={this.showRatePopup}
                >
                    <FormattedMessage id="rate" defaultMessage="Rate" />
                </Button>
            );
        }
        return null;
    };
    blockProviderAction = (data) => {
        var authToken = getCookies();
        axios({
            method: 'post',
            data: {
                provider_id: data.provider_id,
                user_id: this.props.userData.id
            },
            url: `${SERVER_URL}/user/block`,
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            NotificationManager.success("Success", resJson.data.message)
            this.setState({
                showBlockProviderButton: false
            })
        })
    }
    renderBlockProviderButton = data => {
        console.log("showBlockProvider::::", this.state.showBlockProviderButton, !data.is_blocked)
        if (this.state.showBlockProviderButton && !data.is_blocked) {
            return (
                <Button className="d-none"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        this.blockProviderAction(data);
                    }}
                >
                    <FormattedMessage id="blockprovider" defaultMessage="BlockProvider" />
                </Button>
            );
        }

    };
    showRatePopup = () => {
        this.setState({ ratePopup: true });
    };
    renderPayButton = data => {
        if (!data.customer_approved && this.state.showPayButton) {
            return (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={this.showPaymentOptions}
                >
                    <FormattedMessage id="pay" defaultMessage="Pay" />
                </Button>
            );
        }
        return null;
    }

    refundClick = () => {
        this.setState({
            showRefundPopup: true
        })
        console.log("refund");
    }

    refundAction = data => {
        console.log("matre", data);
        var authToken = getCookies();
        axios({
            method: 'post',
            data: {
                booking_id: data.key,
                reason: this.state.reasonRefund
            },
            url: `${SERVER_URL}/booking/refund-request`,
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            if (resJson.data.status == "OK") {
                NotificationManager.success("Success", resJson.data.message)
                this.setState({
                    showRefundBtn: false,
                    showRefundPopup: false
                })
            } else {
                NotificationManager.error("Oops", resJson.data.message)
                this.setState({
                    showRefundPopup: false
                })
            }
        })
    }

    raiseAction = (data) => {
        var authToken = getCookies();
        axios({
            method: 'post', //you can set what request you want to be
            url: `${SERVER_URL}/booking/raise-prices`,
            headers: {
                'x-auth-Token': authToken
            },
            data: {
                bookingToken: data.token,
                raisePrice: this.state.raisePrice,
                raiseReason: this.state.raiseReason
            }

        }).then(response => {
            console.log('Increment booking response:::::::::', response)
            if (response.data.status == "OK") {
                NotificationManager.success("Success", response.data.message)
                this.setState({
                    showRaisePriceModel: false
                })
            }

            else {
                NotificationManager.error("Oops", response.data.message)
                this.setState({
                    showRaisePriceModel: false
                })
            }
        })

    }
    onTheWay = (data) => {
        var authToken = getCookies();
        axios({
            method: 'post', //you can set what request you want to be
            url: `${SERVER_URL}/booking/ontheway`,
            headers: {
                'x-auth-Token': authToken
            },
            data: {
                token: data.token,
            }

        }).then(response => {
            console.log('On the Way response:::::::::', response)
            if (response.data.status == "OK") {
                NotificationManager.success("Success", response.data.message)
                this.getData();
            }
            else {
                NotificationManager.error("Oops", response.data.message)
            }
        })
    }

    renderRefundButton = data => {
        if (data.can_request_refund && this.state.showRefundBtn) {
            return (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => { this.refundClick() }}
                >
                    <FormattedMessage id="refund" defaultMessage="Refund" />
                </Button>
            );
        }
        return null;
    };

    redirectTOSos = () => {
        this.setState({
            sosLoader: true
        })
        var authToken = getCookies();
        axios({
            method: 'get',
            url: `${SERVER_URL}/sos/hit`,
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            if (resJson.data.status == "OK") {
                NotificationManager.success("Success", resJson.data.message)
                this.setState({
                    sosLoader: false
                })
            } else {
                NotificationManager.error("Oops", resJson.data.message)
                this.setState({
                    sosLoader: false
                })
            }
        })
    }

    showPaymentOptions = () => {
        this.setState({ showPaymentOption: true });
    };
    renderAllPaymentOptions = () => {
        let { paymentOptions } = this.props.settings.constants;

        if (Array.isArray(paymentOptions)) {
            paymentOptions = paymentOptions.filter(function (item, index) {
                return item.label != 'Paypal' && item.label != 'Payfast';
            });
        }

        return (
            <div className="text-center">
                {paymentOptions &&
                    paymentOptions.map((option, index) => {
                        if (option.value != 1) {
                            return (
                                <Button
                                    style={{ marginRight: 10 }}
                                    key={index}
                                    variant="contained"
                                    color="primary"
                                    value={option.value}
                                    name="paymentType"
                                    onClick={() =>
                                        this.proceedPayment(option.value)
                                    }
                                >
                                    <FormattedMessage
                                        id="payBy"
                                        defaultMessage="Pay by "
                                    />{' '}
                                    {option.label}
                                </Button>
                            );
                        }
                    })}
            </div>
        );
    };

    proceedPayment = value => {
        if (value == 2) {
            this.setState({ cardPayment: true });
        } else if (value == 3) {
            this.props.walletPayAction(
                { bookingToken: this.state.data.token },
                this.onPaymentDone
            );
            // this.setState({ walletPayment: true });
        } else if (value == 4) {
            this.setState({ redirectPayfastPayment: true });
        }
    };

    onPaymentDone = (success, data) => {
        if (success) {
            this.setState({ showPayButton: false, showPaymentOption: false });
            NotificationManager.success(data.message, 'Success');
        } else {
            NotificationManager.error(data.message, 'Error');
        }
        //api not working for now
    };
    bookingAction = type => {
        // alert("3 ::- "+type)

        // this.setState({ actionLoader: true });
        if (type == 1) {
            console.log("booking 3::::", this.state.data)
            this.props.acceptBookingAction(
                { bookingToken: this.state.data.token },
                this.onActionDone
            );
        } else if (type == 2) {
            console.log("bookin reject:", this.state.data)
            this.props.rejectBookingAction(
                { bookingToken: this.state.data.token },
                this.onActionDone
            );
        } else if (type == 3) {
            this.props.approvePaymentBookingAction(
                { bookingToken: this.state.data.token },
                this.onActionDone
            );
        }
    };
    onActionDone = (success, data) => {
        if (success) {
            NotificationManager.success(
                <FormattedMessage
                    id="actionCompleted"
                    defaultMessage="Action Completed"
                />,
                'Success'
            );
            this.setState({ redirect: true });


        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="blocked"
                    defaultMessage="You are blocked by user,so cannot accpeted the booking"
                />,
                'Error'
            );
        }
    };
    renderProviderOptions = data => {
        if (this.state.actionLoader) {
            return (
                <div className="text-center">
                    <CircularProgress />
                </div>
            );
        } else {
            var bookingDate = new Date(parseInt(data.datetime)).getDate()
            var todayDate = new Date().getDate()

            if (data.statusId == BOOKING_STATUS_CONFIRMED) {
                if (data.statusId == BOOKING_STATUS_CONFIRMED) {
                    return this.renderCancelProviderOption(data)
                } else if (!data.ontheway && bookingDate == todayDate) {
                    return (<div className="text-center">
                        <Button
                            style={{ marginRight: 10 }}
                            key="ontheway"
                            variant="contained"
                            color="primary"
                            value="ontheway"
                            name="ontheway"
                            onClick={() => { this.onTheWay(data) }}
                        >
                            On The Way
                        </Button>
                    </div>)
                }

            }

            if (data.statusId == BOOKING_STATUS_INITIATED) {
                return (
                    <div>
                        <div className="text-center">
                            <Button
                                style={{ marginRight: 10, background: "#1FBB54", color: "#ffffff" }}
                                key="accept"
                                variant="contained"
                                color="primary"
                                value="accept"
                                name="paymentType"
                                onClick={() => this.bookingAction(1)}
                            >
                                <FormattedMessage
                                    id="accept"
                                    defaultMessage="Accept"
                                />
                            </Button>

                            <Button
                                style={{ marginRight: 10, background: "#ff0000", color: "#ffffff" }}
                                key="reject"
                                variant="contained"
                                color="primary"
                                value="reject"
                                name="paymentType"

                                onClick={() => this.bookingAction(2)}
                            >
                                <FormattedMessage
                                    id="reject"
                                    defaultMessage="Reject"
                                />
                            </Button>
                        </div>
                    </div>
                );
            } else if (
                data.statusId == BOOKING_STATUS_END
            ) {
                if (data.customer_rated == "" && data.customer_rated == false) {
                    return (
                        <div className="d-flex justify-content-center row md-12">
                            <Button
                                style={{ marginRight: 10 }}
                                key="accept"
                                variant="contained"
                                color="primary"
                                value="complete"
                                name="paymentType"
                                onClick={() => this.setState({
                                    showRateCustomerPopup: true
                                })}
                            >
                                Rate
                            </Button>
                            {data.payment_status == PAYMENT_PENDING &&
                                <div className="text-center ml-2">
                                    <Button
                                        style={{ marginRight: 10 }}
                                        key="accept"
                                        variant="contained"
                                        color="primary"
                                        value="complete"
                                        name="paymentType"
                                        onClick={() => this.bookingAction(3)}
                                    >
                                        <Check />{' '}
                                        <FormattedMessage
                                            id="approvePayment"
                                            defaultMessage="Approve Payment"
                                        />
                                    </Button>
                                </div>
                            }
                        </div>

                    );
                } else if (data.payment_status == PAYMENT_PENDING) {
                    return (
                        <div className="text-center ml-2">
                            <Button
                                style={{ marginRight: 10 }}
                                key="accept"
                                variant="contained"
                                color="primary"
                                value="complete"
                                name="paymentType"
                                onClick={() => this.bookingAction(3)}
                            >
                                <Check />{' '}
                                <FormattedMessage
                                    id="approvePayment"
                                    defaultMessage="Approve Payment"
                                />
                            </Button>
                        </div>
                    )
                }
            } else if (data.statusId == BOOKING_STATUS_CONFIRMED /* && data.services[0].package_id == null && data.services[0].package_id == "" */) {

                if (data.raise_status == 'na') {
                    return (<div className="text-center">
                        <Button
                            style={{ marginRight: 10 }}
                            key="raise-status"
                            variant="contained"
                            color="primary"
                            value="accept"
                            name="paymentType"
                            onClick={() => {
                                this.setState({
                                    showRaisePriceModel: true
                                })
                            }}
                        >
                            Request Price Increment
                        </Button>
                    </div>)
                } else if (data.raise_status === 'new') {
                    return (<div className="text-center">
                        Waiting for Approval...
                    </div>)
                } else if (data.raise_status === 'rejected') {
                    return (<div className="text-center">
                        Your Price Increment Request is Rejected
                    </div>)
                } else if (data.raise_status === 'accepted') {
                    return (<div className="text-center">
                        Your Price Increment Request is Accepted
                    </div>)
                }

            }
        }
    };
    handleRatingClose = () => {
        this.setState({ ratePopup: false });
    };

    ratingDoneCheck = () => {
        this.setState({ ratingDone: true, });
    };


    onChangeDate = event => {
        console.log("date event::::::::", event)
        const dateTimeValue = moment(event).format('Y-MM-DD');

        this.setState({ openDateTime: true, dateTimeValue: dateTimeValue });
        this.getSlots(dateTimeValue);
    };

    getSlots = chosenDate => {

        console.log("chooosen date::::::::::::::::", chosenDate)
        console.log("Provider ID::::::::::::::::", this.state.data.provider_id)

        this.props.bookingTimeSlotAction(
            {
                providerId: this.state.data.provider_id,
                day: new Date(chosenDate).getDay(),

                date: chosenDate,
                offset: new Date().getTimezoneOffset(),
                currentDate: new Date()
            },

            this.onDateTimeSelected
        );
    };

    closeDialog = () => {
        console.log("kapil")
        this.setState({
            showReschedulePopup: false,
            showRebookPopup: false
        })
    }
    closeRefundDialog = () => {
        this.setState({
            showRefundPopup: false
        })
    }
    onDateTimeSelected = (success, data) => {
        if (success) {
            this.setState({
                slots: data.data.slots,
                haveSlots: true,
                openDateTime: false,


            });
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="noSlotsAvailable"
                    defaultMessage="Sorry No Slots Available"
                />,
                'Error'
            );
        }
    };

    closeTimeSlotPopup = () => {
        this.setState({ haveSlots: false });
    };

    setTimeSlot = slot => {
        const timeValue = getOffSetTime(slot.start);

        this.setState({ timeSlot: timeValue, bookingTimeSlot: slot });
    };
    handleShareIconClose = () => {
        this.setState({
            showShareIcon: false
        })
    }

    closeRaisePriceDialog = () => {
        this.setState({
            showRaisePriceModel: false
        })
    }

    handleCloseRateCustomerPopup = () => {
        this.setState({
            showRateCustomerPopup: false
        })
    }

    changeRating = (newRating, name) => {
        this.setState(
            {
                [name]: newRating
            }
        );
    };

    handleCloseZoomImage = () => {
        this.setState({
            zoomImageModal: false
        })
    }

    shareIcon() {
        return (
            <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">    <path d="M 18 2 A 3 3 0 0 0 15 5 A 3 3 0 0 0 15.054688 5.5605469 L 7.9394531 9.7109375 A 3 3 0 0 0 6 9 A 3 3 0 0 0 3 12 A 3 3 0 0 0 6 15 A 3 3 0 0 0 7.9355469 14.287109 L 15.054688 18.439453 A 3 3 0 0 0 15 19 A 3 3 0 0 0 18 22 A 3 3 0 0 0 21 19 A 3 3 0 0 0 18 16 A 3 3 0 0 0 16.0625 16.712891 L 8.9453125 12.560547 A 3 3 0 0 0 9 12 A 3 3 0 0 0 8.9453125 11.439453 L 16.060547 7.2890625 A 3 3 0 0 0 18 8 A 3 3 0 0 0 21 5 A 3 3 0 0 0 18 2 z" /></svg>
        );
    }

    render() {
        const { classes, userData, settingsValues } = this.props;
        const { formatMessage } = this.props.intl;
        const { data, loader } = this.state;
        if (data.length > 0) {
            var message = String(settingsValues.constants.social_message);
            socialMsg = message.replace("XYZ", data.services[0].service)
        }
        var min = moment().add(-1, 'days');
        var max = moment().add(3, 'month')

        var valid = function (current) {
            return ((min <= current) && (max >= current));
        };

        if (this.state.cardPayment) {
            this.props.history.push({
                pathname: `/booking/payment/${this.state.data.key}`,
                state: { bookingId: this.state.data.key, fromBookingDetail: true }
            });
        }
        if (this.state.redirect) {
            this.props.history.push({
                pathname: `/provider/booking`
            });
        }

        if (this.state.redirectPayfastPayment) {
            return (
                <Redirect
                    to={{
                        pathname: `/booking/payfastpayment/${this.state.data.key
                            }`
                    }}
                />
            );
        }

        return (
            <div>
                <HOCSectionLoader loading={loader}>
                    <Paper>
                        <div className="tableWrapper-table">
                            <Table className="table dashboard-tables">
                                <TableHead>

                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <FormattedMessage
                                                    id="bookingId"
                                                    defaultMessage="Booking ID"
                                                />
                                                : {data.token}
                                            </h4>
                                        </TableCell>
                                        <TableCell className="row">
                                            <Chip
                                                className={getBookingStatusClass(
                                                    !this.state
                                                        .isBookingCancelled
                                                        ? data.status
                                                        : ''
                                                )}
                                                label={
                                                    !this.state
                                                        .isBookingCancelled
                                                        ? data.status
                                                        : 'Cancelled'
                                                }
                                            />
                                            {this.props.userData.role ==
                                                ROLE_CUSTOMER &&
                                                <div className="right btn-floating_img">
                                                    <a class="btn-floating" style={{ "background": "#0078fe" }} >

                                                        <span style={{ "margin-left": "5px" }} onClick={() => {
                                                            this.setState({
                                                                showShareIcon: true
                                                            })
                                                        }}>{this.shareIcon()}</span>
                                                        <Dialog
                                                            id="long-menu"
                                                            open={this.state.showShareIcon}
                                                            onClose={this.handleShareIconClose}
                                                            TransitionComponent={Fade}
                                                            disableBackdropClick={false}
                                                            className="align-self-center md-4"
                                                            aria-labelledby="form-dialog-title"
                                                        /* PaperProps={{
                                                            style: {
                                                                maxHeight: ITEM_HEIGHT * 4.5,
                                                                width: 200,
                                                            },
                                                        }} */
                                                        >
                                                            <MenuItem >
                                                                <FacebookShareButton
                                                                    url={"http://157.245.216.124:3000"}
                                                                    quote={socialMsg}
                                                                >
                                                                    <FacebookIcon size={32} round />
                                                                </FacebookShareButton>
                                                            </MenuItem>
                                                            <MenuItem >
                                                                <TwitterShareButton
                                                                    url={"http://157.245.216.124:3000"}
                                                                    quote={socialMsg}
                                                                >
                                                                    <TwitterIcon size={32} round={true} />
                                                                </TwitterShareButton>
                                                            </MenuItem>
                                                            <MenuItem >
                                                                <a
                                                                    href="https://www.instagram.com/ezprohome/"
                                                                    quote={socialMsg}
                                                                >
                                                                    <img src={instgram} size={32} round={true} />
                                                                </a>
                                                            </MenuItem>
                                                        </Dialog>
                                                    </a>
                                                </div>
                                            }



                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.statusId == BOOKING_STATUS_NOSP || data.statusId == BOOKING_STATUS_INITIATED || data.statusId == BOOKING_STATUS_REBOOK || data.statusId == BOOKING_STATUS_CANCELLED ?

                                        ""


                                        : <React.Fragment>
                                            {data.provider == "Not Assigned" ?
                                                null : this.props.userData.role ==
                                                ROLE_CUSTOMER &&
                                                <TableRow>

                                                    {data.bookingImage && (
                                                        <TableCell>
                                                            <img
                                                                width="200px"
                                                                height="200px"
                                                                className="mobile-img-table"
                                                                src={
                                                                    data.bookingImage.medium
                                                                }
                                                            />
                                                        </TableCell>
                                                    )}
                                                    <TableCell className="table_div">
                                                        <div>
                                                            <div className="table_mg">
                                                                <h4>
                                                                    <div className="spave">
                                                                        {data.statusId == BOOKING_STATUS_INCART ? <b style={{ color: "red" }}> Please add another payment before we can book the job </b> :
                                                                            <React.Fragment>
                                                                                <b style={{ color: "#1fbb54" }}>

                                                                                    {data.provider}   </b>

                                                                            </React.Fragment>
                                                                        }
                                                                    </div>
                                                                </h4>

                                                                <h5 className="ml-3" >
                                                                    <FormattedMessage
                                                                        id="contactDetails"
                                                                        defaultMessage="Contact Details"
                                                                    />
                                                                </h5>

                                                                {data.providerAddress && (
                                                                    <div className="ml-3">
                                                                        <p>
                                                                            {data.providerAddress ? data.providerAddress.address_line1 : '-'}
                                                                        </p>
                                                                        <h5>
                                                                            <FormattedMessage
                                                                                id="phone"
                                                                                defaultMessage="Phone"
                                                                            />
                                                                        </h5>
                                                                        <a style={{ color: "#1fbb54" }} href={"tel:" + data.providerAddress.phone}>
                                                                            {data.providerAddress ? data.providerAddress.phone : '-'}
                                                                        </a>
                                                                        <h5>
                                                                            <FormattedMessage
                                                                                id="email"
                                                                                defaultMessage="Email"
                                                                            />
                                                                        </h5>
                                                                        <a className="email_name" style={{ color: "#1fbb54" }} href={"mailto:" + data.providerAddress.email}>
                                                                            {data.providerAddress ? data.providerAddress.email : '-'}
                                                                        </a>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>


                                            }
                                        </React.Fragment>
                                    }



                                    {this.props.userData.role ==
                                        ROLE_PROVIDER && <TableRow>
                                            <TableCell>
                                                {data.bookingImage && (
                                                    <img
                                                        width="200px"
                                                        className="mobile-img-table"
                                                        height="200px"
                                                        src={data.image.medium}
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell className="text-left">
                                                {data.customerAddress && (
                                                    <div>
                                                        <h4 >
                                                            <b style={{ color: "#1fbb54" }}>
                                                                {data.customerAddress.name}
                                                            </b>
                                                        </h4>
                                                        <h5 className="ml-3" >
                                                            <FormattedMessage
                                                                id="contactDetails"
                                                                defaultMessage="Contact Details"
                                                            />

                                                        </h5>

                                                        <div className="ml-3">
                                                            <p>

                                                                {data.customerAddress.address_line1}
                                                                {', '}
                                                                {data.customerAddress.city}
                                                                {', '}
                                                                {data.customerAddress.country}
                                                                {', '}
                                                                {data.customerAddress.zipcode
                                                                }
                                                            </p>
                                                            <h5>
                                                                <FormattedMessage
                                                                    id="phone"
                                                                    defaultMessage="Phone"
                                                                />
                                                            </h5>
                                                            <a style={{ color: "#1fbb54" }} href={"tel:" + data.customerAddress.phone}>
                                                                {
                                                                    data.customerAddress.phone
                                                                }
                                                            </a>
                                                            <h5>
                                                                <FormattedMessage
                                                                    id="email"
                                                                    defaultMessage="Email"
                                                                />
                                                            </h5>
                                                            <a style={{ color: "#1fbb54" }} href={"mailto:" + data.customerAddress.email}>
                                                                {
                                                                    data.customerAddres ? data.customerAddres.email : '-'
                                                                }
                                                            </a>

                                                        </div>
                                                    </div>
                                                )}
                                            </TableCell>
                                        </TableRow>}
                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    {data.item_type == 1 ? (
                                                        <FormattedMessage
                                                            id="Category"
                                                            defaultMessage="Category"
                                                        />
                                                    ) : (
                                                        <FormattedMessage
                                                            id="Category"
                                                            defaultMessage="Category"
                                                        />
                                                    )}
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4>{this.renderServicemastercategory(data)}</h4>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    {data.item_type == 1 ? (
                                                        <FormattedMessage
                                                            id="Service"
                                                            defaultMessage="Service"
                                                        />
                                                    ) : (
                                                        <FormattedMessage
                                                            id="Service"
                                                            defaultMessage="Service"
                                                        />
                                                    )}
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4>{this.renderServicecategory(data)}</h4>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    {data.item_type == 1 ? (
                                                        <FormattedMessage
                                                            id="Task"
                                                            defaultMessage="Task"
                                                        />
                                                    ) : (
                                                        <FormattedMessage
                                                            id="Task"
                                                            defaultMessage="Task"
                                                        />
                                                    )}
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4>{this.renderService(data)}</h4>
                                        </TableCell>
                                    </TableRow>

                                    {data.parent_recurrance_period != "" &&
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>

                                                        <FormattedMessage
                                                            id="Recurring Type"
                                                            defaultMessage="Recurring Type"
                                                        />
                                                    </b>
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4>
                                                    {data.parent_recurrance_period == 7 ? "Weekly" : data.parent_recurrance_period == 15 ? "Every 2 Weeks" :
                                                        data.parent_recurrance_period == 30 ? "Monthly" : data.parent_recurrance_period == 365 ? "Yearly" : data.parent_recurrance_period == 180
                                                            ? "Bi-Annual" : "-"}
                                                </h4>
                                            </TableCell>
                                        </TableRow>
                                    }


                                    {data.parent_recurrance_period != "" &&
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>

                                                        <FormattedMessage
                                                            id="Proposed Booking Date"
                                                            defaultMessage="Proposed Booking Date"
                                                        />
                                                    </b>
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4>
                                                    {moment(data.datetime + (data.parent_recurrance_period == 7 ? Number("604800000") : data.parent_recurrance_period == 15 ? Number("1296000000") : data.parent_recurrance_period == 30 ? Number("2592000000") : data.parent_recurrance_period == 365 ? Number("31536000000") : data.parent_recurrance_period == 180 ? Number("15552000000") : Number("15552000000"))).format('MM-DD-YYYY')}
                                                </h4>
                                            </TableCell>
                                        </TableRow>
                                    }




                                    {data.recurrance_period != "" &&
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>

                                                        <FormattedMessage
                                                            id="Recurring Type"
                                                            defaultMessage="Recurring Type"
                                                        />
                                                    </b>
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4>
                                                    {data.recurrance_period == 7 ? "Weekly" : data.recurrance_period == 15 ? "Every 2 Weeks" :
                                                        data.recurrance_period == 30 ? "Monthly" : data.recurrance_period == 365 ? "Yearly" : data.recurrance_period == 180
                                                            ? "Bi-Annual" : "-"}
                                                </h4>
                                            </TableCell>
                                        </TableRow>
                                    }

                                    {data.recurrance_period != "" &&
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>

                                                        <FormattedMessage
                                                            id="Proposed Booking Date"
                                                            defaultMessage="Proposed Booking Date"
                                                        />
                                                    </b>
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4>
                                                    {moment(data.datetime + (data.recurrance_period == 7 ? Number("604800000") : data.recurrance_period == 15 ? Number("1296000000") : data.recurrance_period == 30 ? Number("2592000000") : data.recurrance_period == 365 ? Number("31536000000") : data.recurrance_period == 180 ? Number("15552000000") : Number("15552000000"))).format('MM-DD-YYYY')}
                                                </h4>
                                            </TableCell>
                                        </TableRow>
                                    }

                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    <FormattedMessage
                                                        id="schedule"
                                                        defaultMessage="Schedule"
                                                    />
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4>
                                                {moment(data.datetime).format('MM-DD-YYYY')}
                                                {' '}
                                                | {getDay(data.datetime)}

                                            </h4>

                                            <h4><Chip
                                                color="primary"
                                                id="bit_list"
                                                label={tConvert(
                                                    new Date(data.datetime)
                                                ) + ' - ' + tConvert3Add(
                                                    new Date(data.datetime)
                                                )}
                                            /></h4>

                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    <FormattedMessage
                                                        id="service_type"
                                                        defaultMessage="Service Type"
                                                    />
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4>
                                                {this.renderServicetype(data)}
                                            </h4>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    <FormattedMessage
                                                        id="qty"
                                                        defaultMessage="Quantity"
                                                    />
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4>
                                                {this.renderServiceQty(data)}
                                            </h4>
                                        </TableCell>
                                    </TableRow>

                                    {this.props.userData.role ==
                                        ROLE_CUSTOMER &&
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>
                                                        <FormattedMessage
                                                            id="Price"
                                                            defaultMessage="Price"
                                                        />
                                                    </b>
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4 className='singal_line'>
                                                    ${this.renderprice(data)}
                                                </h4>
                                            </TableCell>
                                        </TableRow>
                                    }

                                    {this.props.userData.role ==
                                        ROLE_PROVIDER &&

                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>
                                                        <FormattedMessage
                                                            id="Price"
                                                            defaultMessage="Price"
                                                        />
                                                    </b>
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4 className='singal_line'>
                                                    ${this.renderprowiderprice(data)}
                                                </h4>
                                            </TableCell>
                                        </TableRow>

                                    }
                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    <FormattedMessage
                                                        id="promoCodeApplied"
                                                        defaultMessage="Promo Code Applied"
                                                    />
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4>
                                                {data.promo_code ? data.promo_code.code : '-'}
                                            </h4>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    <FormattedMessage
                                                        id="DiscountedAmount"
                                                        defaultMessage="Discounted Amount"
                                                    />
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4>
                                                {this.rendertotal(data) && data.promo_code ? this.rendertotal(data) : '-'}

                                            </h4>
                                        </TableCell>
                                    </TableRow>

                                    {this.props.userData.role ==
                                        ROLE_PROVIDER &&
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>
                                                        <FormattedMessage
                                                            id="totalAmount"
                                                            defaultMessage="Total Amount"
                                                        />
                                                    </b>
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4 className='singal_line'>
                                                    {
                                                        this.props.settings
                                                            .constants
                                                            .CURRENCY_SYMBOL
                                                    }
                                                    {this.renderTotalAmountprice(data)}
                                                </h4>
                                            </TableCell>
                                        </TableRow>

                                    }

                                    {this.props.userData.role ==
                                        ROLE_CUSTOMER &&
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>
                                                        <FormattedMessage
                                                            id="totalAmount"
                                                            defaultMessage="Total Amount"
                                                        />
                                                    </b>
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4 className='singal_line'>
                                                    {
                                                        this.props.settings
                                                            .constants
                                                            .CURRENCY_SYMBOL
                                                    }
                                                    {this.renderTotalAmount(data)}
                                                </h4>
                                            </TableCell>
                                        </TableRow>

                                    }
                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    <FormattedMessage
                                                        id="paymentStatus"
                                                        defaultMessage="Payment Status"
                                                    />
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4><Chip
                                                id="bit_list"
                                                className={getBookingPaymentStatusClass(
                                                    data.payment_status
                                                )}
                                                label={getBookingPaymentStatus(
                                                    data.payment_status
                                                )}
                                            /></h4>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    <FormattedMessage
                                                        id="paymentType"
                                                        defaultMessage="Payment Type"
                                                    />
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4> <Chip id="bit_list"
                                                className={getPaymentTypeClass(
                                                    data.payment_type
                                                )}
                                                label={getPaymentType(
                                                    data.payment_type
                                                )}
                                            />


                                                <span className="ml-2">
                                                    {data.customer_card_digit != "" ? data.customer_card_digit : ""}

                                                </span></h4>
                                        </TableCell>
                                    </TableRow>

                                    {data.refund_status != "" &&
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>
                                                        <FormattedMessage
                                                            id="RefundStatus"
                                                            defaultMessage="Refund  Status"
                                                        />
                                                    </b>
                                                </h4>
                                            </TableCell>



                                            <TableCell>
                                                <h4>{data.refund_status}</h4>
                                            </TableCell>
                                        </TableRow>
                                    }


                                    {data.refund_status == "Completed" ? <React.Fragment>

                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>
                                                        <FormattedMessage
                                                            id="refund Details"
                                                            defaultMessage="Refund Details"
                                                        />
                                                    </b>
                                                </h4>
                                            </TableCell>


                                            <TableCell>
                                                <h4>{data.refund_details}</h4>
                                            </TableCell>
                                        </TableRow>

                                    </React.Fragment> : ''}





                                    {data.note != "" && <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    <FormattedMessage
                                                        id="additionalNote"
                                                        defaultMessage="Additional Note"
                                                    />
                                                </b>
                                            </h4>
                                        </TableCell>
                                        <TableCell>
                                            <h4>
                                                <b>{data.note}</b>
                                            </h4>
                                        </TableCell>
                                    </TableRow>}
                                    {data.reschedule_info && data.reschedule_status &&
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>
                                                        Reschedule Status
                                                    </b>
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4>
                                                    {data.reschedule_info.status}
                                                </h4>

                                            </TableCell>
                                        </TableRow>}
                                    {data.reschedule_info && data.reschedule_status &&
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>
                                                        Reschedule Date
                                                    </b>
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4>
                                                    {moment(data.reschedule_info.new_slot).format("MM-DD-YYYY")}

                                                    {' '}
                                                    | {getDay(data.reschedule_info.new_slot)}
                                                </h4>
                                                <Chip
                                                    color="primary"
                                                    label={tConvert(
                                                        new Date(data.reschedule_info.new_slot)
                                                    ) + ' - ' + tConvert3Add(
                                                        new Date(data.reschedule_info.new_slot)
                                                    )}
                                                />

                                            </TableCell>
                                        </TableRow>}
                                    {data.refund_request == "true" &&


                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>
                                                        Refund Status
                                                    </b>
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4>
                                                    {data.refund_status}
                                                </h4>

                                            </TableCell>
                                        </TableRow>
                                    }
                                    {data.refund_request == "true" &&
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>
                                                        Refund Mode
                                                    </b>
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4>
                                                    {data.refund_mode}
                                                </h4>

                                            </TableCell>
                                        </TableRow>
                                    }
                                    {data.refund_request == "true" &&
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>
                                                        Refund Date
                                                    </b>
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4>
                                                    {moment(data.refund_date).format("MM-DD-YYYY")}
                                                </h4>

                                            </TableCell>
                                        </TableRow>
                                    }

                                    {data.provider == "Not Assigned" ?
                                        null : this.props.userData.role ==
                                        ROLE_CUSTOMER &&
                                        <React.Fragment>
                                            {data.raise_status === "new" &&
                                                <TableRow>
                                                    <TableCell>
                                                        <h4>
                                                            Price Raise Request
                                                        </h4>
                                                    </TableCell>
                                                    {this.state.isAccepting || this.state.isRejecting ?
                                                        <TableCell>
                                                            <CircularProgress />
                                                        </TableCell>
                                                        :
                                                        <TableCell>
                                                            <Button
                                                                className="ml-2"
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={() => this.handleRaiseRequestAccept(data)}
                                                            >
                                                                <FormattedMessage id="accept" defaultMessage="Accept" />
                                                            </Button>

                                                            <Button
                                                                className="ml-2"
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={() => this.handleRaiseRequestReject(data)}
                                                            >
                                                                <FormattedMessage id="reject" defaultMessage="Reject" />
                                                            </Button>
                                                        </TableCell>
                                                    }

                                                </TableRow>
                                            }
                                        </React.Fragment>


                                    }

                                    {data.raise_status === "new" && data.raised_price !== "" &&
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    Proposed Price
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4>
                                                    {data.raised_price}
                                                </h4>

                                            </TableCell>

                                        </TableRow>
                                    }

                                    {data.raise_status === "new" && data.raise_reason !== "" &&
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    Raise Reason
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4>
                                                    {data.raise_reason}
                                                </h4>

                                            </TableCell>

                                        </TableRow>
                                    }


                                    {data.rating && (
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>
                                                        <FormattedMessage
                                                            id="rating"
                                                            defaultMessage="Rating"
                                                        />
                                                    </b>
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4>
                                                    {data.rating
                                                        ? data.rating.ar
                                                        : ''}
                                                    /5
                                                </h4>

                                                <p className="ml-3">
                                                    {data.rating
                                                        ? ` ${data.rating.review
                                                        } `
                                                        : ''}
                                                </p>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    <TableRow>
                                        <TableCell >
                                            <h4>
                                                <FormattedMessage
                                                    id="createdAt"
                                                    defaultMessage="Created At"
                                                />:
                                            </h4>
                                        </TableCell>
                                        <TableCell>
                                            <h4>

                                                {' '}
                                                {moment(data.created_at).format("MM-DD-YYYY")}
                                                {' '}
                                            </h4>

                                        </TableCell>
                                    </TableRow>
                                    {data.customer_images && data.customer_images.length > 0 &&
                                        <TableRow>
                                            <TableCell colSpan="2">
                                                <h4>
                                                    Booking Images
                                                </h4>
                                            </TableCell>

                                        </TableRow>
                                    }

                                    {data.customer_images && data.customer_images.length > 0 &&
                                        <TableRow>
                                            <TableCell colSpan="2">
                                                <div className="md-12 row">
                                                    {data.customer_images.map(images => {
                                                        return (
                                                            <div className="col-md-3 P-2 mt-1 mb-1">
                                                                <img alt="Crop" src={images.small} onClick={() => {
                                                                    this.setState({
                                                                        zoomImageModal: true,
                                                                        zoomSrc: images.large
                                                                    })
                                                                }}
                                                                    style={{ width: "100%", height: "100%" }} />
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    }

                                    {data.end_provider_images && data.end_provider_images.length > 0 &&
                                        <TableRow>
                                            <TableCell colSpan="2">
                                                <h4>
                                                    Provider Images
                                                </h4>
                                            </TableCell>

                                        </TableRow>
                                    }

                                    {data.end_provider_images && data.end_provider_images.length > 0 &&
                                        <TableRow>
                                            <TableCell colSpan="2">
                                                <div className="md-12 row">
                                                    {data.end_provider_images.map(images => {
                                                        return (
                                                            <div className="col-md-3 P-2 mt-1 mb-1">
                                                                <img alt="Crop" src={images.small} onClick={() => {
                                                                    this.setState({
                                                                        zoomImageModal: true,
                                                                        zoomSrc: images.large
                                                                    })
                                                                }}
                                                                    style={{ width: "100%", height: "100%" }} />
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    }

                                    {data.end_provider_comment && data.end_provider_comment != "" && <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    Provider Remarks
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4>
                                                {data.end_provider_comment}
                                            </h4>
                                        </TableCell>
                                    </TableRow>}



                                </TableBody>
                                {userData.role == ROLE_CUSTOMER && (
                                    <TableFooter>
                                        <TableRow>
                                            <TableCell colSpan="2">
                                                {!this.state.showPaymentOption
                                                    ? this.renderActions(data)
                                                    : this.renderAllPaymentOptions(
                                                        data
                                                    )}
                                            </TableCell>
                                        </TableRow>
                                    </TableFooter>
                                )}

                                <TableFooter>
                                    {userData.role == ROLE_PROVIDER && (
                                        <TableRow>
                                            <TableCell colSpan="2">
                                                {this.renderProviderOptions(
                                                    data
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {userData.role == ROLE_PROVIDER && settingsValues.constants.ontheway_message != "" && data.ontheway &&
                                        data.statusId == BOOKING_STATUS_CONFIRMED && (
                                            <TableRow>
                                                <TableCell colSpan="2">
                                                    <p>{settingsValues.constants.ontheway_message}</p>
                                                </TableCell>
                                            </TableRow>
                                        )}

                                </TableFooter>
                            </Table>
                        </div>
                    </Paper>

                    {this.state.ratePopup && (
                        <RatingPopup
                            open={this.state.ratePopup}
                            close={this.handleRatingClose}
                            r1Value={this.props.settings.constants.R1}
                            r2Value={this.props.settings.constants.R2}
                            r3Value={this.props.settings.constants.R3}
                            arValue={this.props.settings.constants.AR}
                            starRatedColor={
                                this.props.settings.colors.RATING.HEX
                            }
                            bookingToken={this.state.data.token}
                            reviewDone={this.ratingDoneCheck}
                        />
                    )}


                </HOCSectionLoader>

                <Dialog
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    fullWidth={true}
                    className="align-self-center md-12"
                    open={this.state.showReschedulePopup}
                    onClose={this.closeDialog}
                    aria-labelledby="form-dialog-title"
                >
                    <div style={{ backgroundColor: "white" }} className="custom-input-text col p-3">

                        <form className="form-new">
                            <div className="row">
                                <div className="col-md-6 ml-2 mt-1">

                                    <DateTimePanel
                                        className="login-form-textfield datetime"
                                        open={
                                            this.state
                                                .openDateTime
                                        }
                                        isValidDate={valid}
                                        timeFormat={false}
                                        onChange={
                                            this.onChangeDate
                                        }
                                        value={
                                            this.state
                                                .dateTimeValue
                                        }
                                    />
                                </div>
                                {this.state.dateTimeValue != "" && <div className="col-md-6 ml-2 mt-1">
                                    <h4 className="mb-2">
                                        <FormattedMessage
                                            id="time"
                                            defaultMessage="Time"
                                        />
                                        :
                                    </h4>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                    >
                                        {
                                            this.state
                                                .bookingTimeSlot
                                                .label
                                        }
                                    </Button>
                                </div>}
                            </div>
                            <div className="mr-2 mb-4 mt-4 col-md-12 " style={{ marginLeft: -10 }}>
                                <TextField id="standard-basic" label="Reason"
                                    className="login-form-textfield"
                                    placeholder="Enter Reason"
                                    fullWidth={true}
                                    onChange={event => {
                                        this.setState({
                                            reason: event.target.value,
                                        });
                                    }} />
                            </div>


                            <div className="col-md-12" style={{ display: "flex", justifyContent: "center" }}>
                                <a
                                    className="custom-button"
                                    onClick={() => this.onRescheduleClick(data)}
                                    href="javascript:void(0)"
                                > RESCHEDULE
                                </a>
                            </div>
                        </form>
                    </div>
                </Dialog>

                <Dialog
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    fullWidth={true}
                    className="align-self-center md-12"
                    open={this.state.showRebookPopup}
                    onClose={this.closeDialog}
                    aria-labelledby="form-dialog-title"
                >
                    <div style={{ backgroundColor: "white" }} className="custom-input-text col p-3">

                        <form className="form-new ">
                            <div className="row">
                                <div className="col-md-6 ml-2 mt-1 datetime">

                                    <DateTimePanel
                                        className="login-form-textfield"
                                        open={
                                            this.state
                                                .openDateTime
                                        }
                                        isValidDate={valid}
                                        timeFormat={false}
                                        onChange={
                                            this.onChangeDate
                                        }
                                        value={
                                            this.state
                                                .dateTimeValue
                                        }
                                    />
                                </div>
                                {this.state.dateTimeValue != "" && <div className="col-md-6 ml-2 mt-1">
                                    <h4 className="mb-2">
                                        <FormattedMessage
                                            id="time"
                                            defaultMessage="Time"
                                        />
                                        :
                                    </h4>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                    >
                                        {
                                            this.state
                                                .bookingTimeSlot
                                                .label
                                        }
                                    </Button>
                                </div>}

                                <div className="mr-2 mb-4 mt-4 col-md-12 " style={{ marginLeft: -10 }}>

                                </div>

                            </div>



                            <div className="col-md-12" style={{ display: "flex", justifyContent: "center" }}>
                                <a
                                    className="custom-button"
                                    onClick={() => this.onREBOOKClick(data)}
                                    href="javascript:void(0)"
                                > Rebook Job
                                </a>
                            </div>
                        </form>
                    </div>
                </Dialog>




                <Dialog
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    fullWidth={true}
                    className="align-self-center md-12"
                    open={this.state.showRefundPopup}
                    onClose={this.closeRefundDialog}

                    aria-labelledby="form-dialog-title"
                >
                    <div className="ml-2 mr-2 mb-2 mt-2 md-9">

                        <textarea id="standard-basic" label="Enter Refund Reason" placeholder="Enter Refund Reason"
                            variant="contained" rows="4" multiline fullWidth onChange={event => {
                                this.setState({
                                    reasonRefund: event.target.value,
                                });
                            }}></textarea>
                    </div>



                    <div className="col-md-12 mb-4" style={{ display: "flex", justifyContent: "center" }}>
                        <a
                            className="custom-button"
                            onClick={() => this.refundAction(data)}
                            href="javascript:void(0)"
                        > Refund
                        </a>
                    </div>
                </Dialog>

                <Dialog
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    fullWidth={true}
                    className="align-self-center md-12"
                    open={this.state.showRaisePriceModel}
                    onClose={this.closeRaisePriceDialog}
                    aria-labelledby="form-dialog-title"
                >

                    <div className="form-new mt-2">
                        <TextField
                            className="login-form-textfield"
                            id="old price"
                            fullWidth={true}
                            name="Old Price"
                            placeholder={"Old Price"}
                            value={data.length > 0 ? data.services[0].servicePrice : "0"}
                            disabled={true}
                        />
                    </div>

                    <div className="form-new mt-2">
                        <TextField
                            className="login-form-textfield"
                            id="raise price"
                            fullWidth={true}
                            name="Raise price"
                            placeholder={"Enter Raise price"}
                            value={this.state.raisePrice}
                            onChange={event => {
                                this.setState({
                                    raisePrice: event.target.value,
                                });
                            }}
                        />
                    </div>
                    <div className="form-new mt-2">
                        <TextField
                            className="login-form-textfield"
                            id="raise reason"
                            fullWidth={true}
                            name="Raise reason"
                            placeholder={"Raise price reason"}
                            value={this.state.raiseReason}
                            onChange={event => {
                                this.setState({
                                    raiseReason: event.target.value,
                                });
                            }}
                        />
                    </div>


                    <Button
                        className="ml-2 mt-2 mb-3" style={{ width: "30%", alignSelf: "center" }}
                        variant="contained"
                        color="primary"
                        onClick={() => this.raiseAction(data)}
                    >
                        Raise
                    </Button>
                </Dialog>

                <Dialog
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    className="text-center"
                    open={this.state.showRateCustomerPopup}
                    onClose={this.handleCloseRateCustomerPopup}
                    aria-labelledby="form-dialog-title"
                >
                    <form className="dialog-form">
                        <div
                            className="dialog-header"
                        >
                            <h3 className="dialog-heading">Rate Customer</h3>
                        </div>
                        <div className="dialog-body">
                            <DialogContent>
                                <div className="text-center">
                                    <h4>ive him stars to make his day</h4>
                                    <StarRatings
                                        rating={this.state.r1}
                                        starRatedColor={"yellow"}
                                        changeRating={this.changeRating}
                                        numberOfStars={5}
                                        name="r1"
                                        starDimension="30px"
                                        starSpacing="15px"
                                        starHoverColor={
                                            "yellow"
                                        }
                                    />
                                </div>
                                <TextField
                                    label="Review"
                                    id="review"
                                    fullWidth={true}
                                    name="review"
                                    type="text"
                                    value={this.state.reviewCustomer}
                                    onChange={event => {
                                        this.setState({
                                            reviewCustomer: event.target.value,
                                        });
                                    }}
                                />
                            </DialogContent>

                            <DialogActions>
                                <div className="text-center">
                                    <Button
                                        style={{ marginRight: 10 }}
                                        key="accept"
                                        variant="contained"
                                        color="primary"
                                        value="complete"
                                        name="paymentType"
                                        onClick={() => this.rateCustomer(data)}
                                    >
                                        Review
                                    </Button>
                                </div>
                            </DialogActions>
                        </div>
                    </form>
                </Dialog>
                {this.state.haveSlots && (
                    <BookingTimeSlotPopup
                        isVisible={this.state.haveSlots}
                        closePopup={this.closeTimeSlotPopup}
                        slots={this.state.slots}
                        onTimeSlotSelected={this.setTimeSlot}
                        isTodaySlot={this.state.isTodaySlot}
                    />
                )}

                {this.state.zoomImageModal && <Dialog fullScreen
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                    }} open={this.state.zoomImageModal}
                    onClose={this.handleCloseZoomImage} TransitionComponent={Transition}>
                    <AppBar style={{ position: "relative" }}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={this.handleCloseZoomImage} aria-label="close">
                                <Close />
                            </IconButton>

                        </Toolbar>

                    </AppBar>
                    <div className="d-flex justify-content-center" style={{
                        width: "100%", height: "100%",
                        background: "rgba(0,0,0,0.2)", alignContent: "center", alignItems: "center"
                    }}>
                        <Zoom wrapStyle={{ background: null }}>
                            <img alt="crop" src={this.state.zoomSrc} width={500}
                                /* style={{ width: 600, height: 700, }} */ />
                        </Zoom>
                    </div>
                </Dialog>}
            </div>
        );
    }

}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const mapStateToProps = ({ settings, auth }) => {
    return { settingsValues: settings, userData: auth.userData };
};
const composedComponent = compose(
    withStyles(styles),
    connect(
        mapStateToProps,
        actions
    )
);
export default composedComponent(withCustomTheme(injectIntl(BookingDetail)));



// WEBPACK FOOTER //
// ./src/components/Customer/BookingDetail.jsx